import { render, staticRenderFns } from "./bimInvitePopup.vue?vue&type=template&id=6ad07cb1&scoped=true&lang=html&"
import script from "./bimInvitePopup.vue?vue&type=script&lang=js&"
export * from "./bimInvitePopup.vue?vue&type=script&lang=js&"
import style0 from "./bimInvitePopup.vue?vue&type=style&index=0&id=6ad07cb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad07cb1",
  null
  
)

export default component.exports